// Automatically generated with Reach 0.1.8 (dab71275)
/* eslint-disable */
export const _version = '0.1.8';
export const _versionHash = '0.1.8 (dab71275)';
export const _backendVersion = 7;

export function getExports(s) {
  const stdlib = s.reachStdlib;
  return {
    };
  };
export function _getEvents(s) {
  const stdlib = s.reachStdlib;
  return {
    };
  };
export function _getViews(s, viewlib) {
  const stdlib = s.reachStdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Bool;
  
  return {
    infos: {
      Auction: {
        bids: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v733, v734, v735, v736, v740] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v780, v805, v806] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1411, v1415] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1479, v1484] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        closed: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v733, v734, v735, v736, v740] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v780, v805, v806] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1411, v1415] = svs;
              return (await ((async () => {
                
                
                return true;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1479, v1484] = svs;
              return (await ((async () => {
                
                
                return true;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849] = svs;
              return (await ((async () => {
                
                
                return false;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc3
          },
        closes: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v733, v734, v735, v736, v740] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v780, v805, v806] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1411, v1415] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1479, v1484] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        currentPrice: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v733, v734, v735, v736, v740] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v780, v805, v806] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1411, v1415] = svs;
              return (await ((async () => {
                
                
                return v817;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1479, v1484] = svs;
              return (await ((async () => {
                
                
                return v817;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849] = svs;
              return (await ((async () => {
                
                
                return v817;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        endCTime: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v733, v734, v735, v736, v740] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v780, v805, v806] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1411, v1415] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1479, v1484] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        endSecs: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v733, v734, v735, v736, v740] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v780, v805, v806] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1411, v1415] = svs;
              return (await ((async () => {
                
                
                return v818;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1479, v1484] = svs;
              return (await ((async () => {
                
                
                return v818;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849] = svs;
              return (await ((async () => {
                
                
                return v818;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        highestBidder: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v733, v734, v735, v736, v740] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v780, v805, v806] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1411, v1415] = svs;
              return (await ((async () => {
                
                
                return v819;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1479, v1484] = svs;
              return (await ((async () => {
                
                
                return v819;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849] = svs;
              return (await ((async () => {
                
                
                return v819;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc0
          },
        lastCTime: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v733, v734, v735, v736, v740] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v780, v805, v806] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1411, v1415] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1479, v1484] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        minBid: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v733, v734, v735, v736, v740] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v780, v805, v806] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1411, v1415] = svs;
              return (await ((async () => {
                
                
                return v1399;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1479, v1484] = svs;
              return (await ((async () => {
                
                
                return v1399;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849] = svs;
              return (await ((async () => {
                
                
                return v849;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        owner: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v733, v734, v735, v736, v740] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v780, v805, v806] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1411, v1415] = svs;
              return (await ((async () => {
                
                
                return v767;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1479, v1484] = svs;
              return (await ((async () => {
                
                
                return v767;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849] = svs;
              return (await ((async () => {
                
                
                return v767;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc0
          },
        reservePrice: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v733, v734, v735, v736, v740] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v780, v805, v806] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1411, v1415] = svs;
              return (await ((async () => {
                
                
                return v770;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1479, v1484] = svs;
              return (await ((async () => {
                
                
                return v770;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849] = svs;
              return (await ((async () => {
                
                
                return v770;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        royalties: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v733, v734, v735, v736, v740] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v780, v805, v806] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1411, v1415] = svs;
              return (await ((async () => {
                
                
                return v769;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1479, v1484] = svs;
              return (await ((async () => {
                
                
                return v769;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849] = svs;
              return (await ((async () => {
                
                
                return v769;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        startPrice: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v733, v734, v735, v736, v740] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v780, v805, v806] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1411, v1415] = svs;
              return (await ((async () => {
                
                
                return v771;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1479, v1484] = svs;
              return (await ((async () => {
                
                
                return v771;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849] = svs;
              return (await ((async () => {
                
                
                return v771;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        token: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v733, v734, v735, v736, v740] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v780, v805, v806] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1411, v1415] = svs;
              return (await ((async () => {
                
                
                return v776;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1479, v1484] = svs;
              return (await ((async () => {
                
                
                return v776;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849] = svs;
              return (await ((async () => {
                
                
                return v776;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc2
          },
        tokenP: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v733, v734, v735, v736, v740] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v780, v805, v806] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1411, v1415] = svs;
              return (await ((async () => {
                
                
                return v777;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1479, v1484] = svs;
              return (await ((async () => {
                
                
                return v777;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849] = svs;
              return (await ((async () => {
                
                
                return v777;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc2
          }
        }
      },
    views: {
      1: [ctc0, ctc0, ctc0, ctc0, ctc0],
      2: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0],
      4: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc3, ctc1, ctc1],
      7: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc3, ctc1, ctc1],
      10: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]
      }
    };
  
  };
export function _getMaps(s) {
  const stdlib = s.reachStdlib;
  const ctc0 = stdlib.T_Tuple([]);
  return {
    mapDataTy: ctc0
    };
  };
export async function Auctioneer(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Auctioneer expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Auctioneer expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Object({
    bidIncrementAbs: ctc1,
    bidIncrementRel: ctc1,
    deadline: ctc1,
    deadlineSecs: ctc1,
    deadlineStep: ctc1,
    maxDeadline: ctc1,
    reservePrice: ctc1,
    royaltyAddr: ctc0,
    royaltyCents: ctc1,
    startPrice: ctc1,
    token: ctc2,
    tokenP: ctc2,
    unitAmount: ctc1
    });
  const ctc4 = stdlib.T_Null;
  const ctc5 = stdlib.T_Tuple([ctc4]);
  const ctc6 = stdlib.T_Tuple([ctc1]);
  const ctc7 = stdlib.T_Data({
    Bid_close0_161: ctc5,
    Bid_getBid0_161: ctc6,
    Bid_getPurchase0_161: ctc6,
    Bid_touch0_161: ctc5
    });
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 4,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v733, v734, v735, v736], secs: v738, time: v737, didSend: v36, from: v732 } = txn1;
  ;
  const v740 = v736;
  const v746 = stdlib.protect(ctc3, await interact.getParams(), {
    at: './token.rsh:96:38:application',
    fs: ['at ./token.rsh:80:18:application call to [unknown function] (defined at: ./token.rsh:80:22:function exp)'],
    msg: 'getParams',
    who: 'Auctioneer'
    });
  const v747 = v746.royaltyAddr;
  const v748 = v746.royaltyCents;
  const v749 = v746.token;
  const v750 = v746.tokenP;
  const v751 = v746.reservePrice;
  const v752 = v746.startPrice;
  const v753 = v746.bidIncrementAbs;
  const v754 = v746.bidIncrementRel;
  const v755 = v746.deadline;
  const v756 = v746.maxDeadline;
  const v757 = v746.unitAmount;
  const v758 = v746.deadlineStep;
  const v759 = v746.deadlineSecs;
  const v760 = stdlib.tokenEq(v749, v750);
  const v761 = v760 ? false : true;
  stdlib.assert(v761, {
    at: './token.rsh:97:11:application',
    fs: ['at ./token.rsh:80:18:application call to [unknown function] (defined at: ./token.rsh:80:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  const v762 = stdlib.ge(v748, stdlib.checkedBigNumberify('./token.rsh:98:28:decimal', stdlib.UInt_max, 0));
  const v763 = stdlib.le(v748, stdlib.checkedBigNumberify('./token.rsh:98:49:decimal', stdlib.UInt_max, 99));
  const v764 = v762 ? v763 : false;
  stdlib.assert(v764, {
    at: './token.rsh:98:11:application',
    fs: ['at ./token.rsh:80:18:application call to [unknown function] (defined at: ./token.rsh:80:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  const v765 = stdlib.ge(v752, stdlib.checkedBigNumberify('./token.rsh:99:26:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v765, {
    at: './token.rsh:99:11:application',
    fs: ['at ./token.rsh:80:18:application call to [unknown function] (defined at: ./token.rsh:80:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  const v766 = stdlib.lt(v752, v751);
  stdlib.assert(v766, {
    at: './token.rsh:100:11:application',
    fs: ['at ./token.rsh:80:18:application call to [unknown function] (defined at: ./token.rsh:80:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  
  const txn2 = await (ctc.sendrecv({
    args: [v733, v734, v735, v736, v740, v747, v748, v751, v752, v753, v754, v755, v756, v749, v750, v757, v758, v759],
    evt_cnt: 13,
    funcNum: 1,
    lct: v737,
    onlyIf: true,
    out_tys: [ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc1],
    pay: [stdlib.checkedBigNumberify('./token.rsh:119:11:decimal', stdlib.UInt_max, 100000), []],
    sim_p: (async (txn2) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v768, v769, v770, v771, v772, v773, v774, v775, v776, v777, v778, v779, v780], secs: v782, time: v781, didSend: v87, from: v767 } = txn2;
      
      const v783 = stdlib.tokenEq(v776, v777);
      const v784 = v783 ? false : true;
      stdlib.assert(v784, {
        at: './token.rsh:103:6:dot',
        fs: [],
        msg: 'non-network tokens distinct',
        who: 'Auctioneer'
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
        kind: 'init',
        tok: v776
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
        kind: 'init',
        tok: v777
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./token.rsh:119:11:decimal', stdlib.UInt_max, 100000),
        kind: 'to',
        tok: undefined
        });
      stdlib.assert(v784, {
        at: './token.rsh:120:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v789 = stdlib.ge(v769, stdlib.checkedBigNumberify('./token.rsh:121:27:decimal', stdlib.UInt_max, 0));
      const v790 = stdlib.le(v769, stdlib.checkedBigNumberify('./token.rsh:121:48:decimal', stdlib.UInt_max, 99));
      const v791 = v789 ? v790 : false;
      stdlib.assert(v791, {
        at: './token.rsh:121:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v792 = stdlib.ge(v771, stdlib.checkedBigNumberify('./token.rsh:122:25:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v792, {
        at: './token.rsh:122:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v793 = stdlib.lt(v771, v770);
      stdlib.assert(v793, {
        at: './token.rsh:123:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v797 = stdlib.sub(stdlib.checkedBigNumberify('./token.rsh:119:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./token.rsh:126:12:decimal', stdlib.UInt_max, 20000));
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./token.rsh:126:12:decimal', stdlib.UInt_max, 20000),
        kind: 'from',
        to: v733,
        tok: undefined
        });
      const v801 = stdlib.sub(v797, stdlib.checkedBigNumberify('./token.rsh:127:12:decimal', stdlib.UInt_max, 30000));
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./token.rsh:127:12:decimal', stdlib.UInt_max, 30000),
        kind: 'from',
        to: v735,
        tok: undefined
        });
      const v805 = stdlib.sub(v801, stdlib.checkedBigNumberify('./token.rsh:128:12:decimal', stdlib.UInt_max, 50000));
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./token.rsh:128:12:decimal', stdlib.UInt_max, 50000),
        kind: 'from',
        to: v736,
        tok: undefined
        });
      const v806 = v767;
      sim_r.isHalt = false;
      
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc1],
    waitIfNotPresent: false
    }));
  const {data: [v768, v769, v770, v771, v772, v773, v774, v775, v776, v777, v778, v779, v780], secs: v782, time: v781, didSend: v87, from: v767 } = txn2;
  const v783 = stdlib.tokenEq(v776, v777);
  const v784 = v783 ? false : true;
  stdlib.assert(v784, {
    at: './token.rsh:103:6:dot',
    fs: [],
    msg: 'non-network tokens distinct',
    who: 'Auctioneer'
    });
  ;
  ;
  ;
  stdlib.assert(v784, {
    at: './token.rsh:120:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v789 = stdlib.ge(v769, stdlib.checkedBigNumberify('./token.rsh:121:27:decimal', stdlib.UInt_max, 0));
  const v790 = stdlib.le(v769, stdlib.checkedBigNumberify('./token.rsh:121:48:decimal', stdlib.UInt_max, 99));
  const v791 = v789 ? v790 : false;
  stdlib.assert(v791, {
    at: './token.rsh:121:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v792 = stdlib.ge(v771, stdlib.checkedBigNumberify('./token.rsh:122:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v792, {
    at: './token.rsh:122:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v793 = stdlib.lt(v771, v770);
  stdlib.assert(v793, {
    at: './token.rsh:123:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v797 = stdlib.sub(stdlib.checkedBigNumberify('./token.rsh:119:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./token.rsh:126:12:decimal', stdlib.UInt_max, 20000));
  ;
  const v801 = stdlib.sub(v797, stdlib.checkedBigNumberify('./token.rsh:127:12:decimal', stdlib.UInt_max, 30000));
  ;
  const v805 = stdlib.sub(v801, stdlib.checkedBigNumberify('./token.rsh:128:12:decimal', stdlib.UInt_max, 50000));
  ;
  const v806 = v767;
  const txn3 = await (ctc.recv({
    didSend: false,
    evt_cnt: 0,
    funcNum: 2,
    out_tys: [],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [], secs: v809, time: v808, didSend: v116, from: v807 } = txn3;
  ;
  ;
  const v813 = stdlib.addressEq(v806, v807);
  stdlib.assert(v813, {
    at: './token.rsh:134:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Auctioneer'
    });
  const v816 = 'Start Auction';
  stdlib.protect(ctc4, await interact.log(v816), {
    at: './token.rsh:139:40:application',
    fs: ['at ./token.rsh:139:7:application call to [unknown function] (defined at: ./token.rsh:139:25:function exp)'],
    msg: 'log',
    who: 'Auctioneer'
    });
  
  let v817 = stdlib.checkedBigNumberify('./token.rsh:170:24:decimal', stdlib.UInt_max, 0);
  let v818 = v780;
  let v819 = v767;
  let v820 = true;
  let v821 = v808;
  let v824 = v809;
  let v827 = v805;
  let v828 = stdlib.checkedBigNumberify('./token.rsh:134:15:decimal', stdlib.UInt_max, 1);
  let v829 = stdlib.checkedBigNumberify('./token.rsh:103:6:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    
    return v820;})()) {
    const v844 = stdlib.add(v817, v772);
    const v845 = stdlib.div(v817, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
    const v846 = stdlib.mul(v845, v773);
    const v847 = stdlib.add(v817, v846);
    const v848 = stdlib.gt(v844, v847);
    const v849 = v848 ? v844 : v847;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc7],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v943], secs: v945, time: v944, didSend: v565, from: v942 } = txn4;
    switch (v943[0]) {
      case 'Bid_close0_161': {
        const v946 = v943[1];
        ;
        ;
        undefined;
        const v995 = null;
        await txn4.getOutput('Bid_close', 'v995', ctc4, v995);
        const v1002 = stdlib.lt(v824, v818);
        const cv817 = v817;
        const cv818 = v818;
        const cv819 = v819;
        const cv820 = v1002;
        const cv821 = v944;
        const cv824 = v945;
        const cv827 = v827;
        const cv828 = v828;
        const cv829 = v829;
        
        v817 = cv817;
        v818 = cv818;
        v819 = cv819;
        v820 = cv820;
        v821 = cv821;
        v824 = cv824;
        v827 = cv827;
        v828 = cv828;
        v829 = cv829;
        
        continue;
        break;
        }
      case 'Bid_getBid0_161': {
        const v1058 = v943[1];
        const v1071 = v1058[stdlib.checkedBigNumberify('./token.rsh:202:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1104 = stdlib.add(v829, v1071);
        ;
        undefined;
        const v1119 = stdlib.lt(v824, v818);
        const v1126 = stdlib.ge(v1071, v849);
        const v1127 = v1119 ? v1126 : false;
        const v1128 = stdlib.ge(v1071, v771);
        const v1129 = v1127 ? v1128 : false;
        stdlib.assert(v1129, {
          at: './token.rsh:209:18:application',
          fs: ['at ./token.rsh:208:9:application call to [unknown function] (defined at: ./token.rsh:208:9:function exp)'],
          msg: null,
          who: 'Auctioneer'
          });
        const v1133 = stdlib.sub(v1104, v817);
        ;
        const v1134 = null;
        await txn4.getOutput('Bid_getBid', 'v1134', ctc4, v1134);
        const v1140 = stdlib.add(v818, stdlib.checkedBigNumberify('./token.rsh:158:33:decimal', stdlib.UInt_max, 60));
        const cv817 = v1071;
        const cv818 = v1140;
        const cv819 = v942;
        const cv820 = true;
        const cv821 = v944;
        const cv824 = v945;
        const cv827 = v827;
        const cv828 = v828;
        const cv829 = v1133;
        
        v817 = cv817;
        v818 = cv818;
        v819 = cv819;
        v820 = cv820;
        v821 = cv821;
        v824 = cv824;
        v827 = cv827;
        v828 = cv828;
        v829 = cv829;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0_161': {
        const v1170 = v943[1];
        const v1191 = v1170[stdlib.checkedBigNumberify('./token.rsh:227:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1216 = stdlib.add(v829, v1191);
        ;
        undefined;
        const v1257 = stdlib.ge(v824, v818);
        const v1258 = stdlib.lt(v817, v770);
        const v1259 = v1257 ? v1258 : false;
        const v1260 = stdlib.ge(v1191, v770);
        const v1261 = v1259 ? v1260 : false;
        stdlib.assert(v1261, {
          at: './token.rsh:235:18:application',
          fs: ['at ./token.rsh:234:9:application call to [unknown function] (defined at: ./token.rsh:234:9:function exp)'],
          msg: null,
          who: 'Auctioneer'
          });
        const v1265 = stdlib.sub(v1216, v817);
        ;
        const v1266 = null;
        await txn4.getOutput('Bid_getPurchase', 'v1266', ctc4, v1266);
        const cv817 = v1191;
        const cv818 = v818;
        const cv819 = v942;
        const cv820 = false;
        const cv821 = v944;
        const cv824 = v945;
        const cv827 = v827;
        const cv828 = v828;
        const cv829 = v1265;
        
        v817 = cv817;
        v818 = cv818;
        v819 = cv819;
        v820 = cv820;
        v821 = cv821;
        v824 = cv824;
        v827 = cv827;
        v828 = cv828;
        v829 = cv829;
        
        continue;
        break;
        }
      case 'Bid_touch0_161': {
        const v1282 = v943[1];
        ;
        ;
        undefined;
        const v1387 = null;
        await txn4.getOutput('Bid_touch', 'v1387', ctc4, v1387);
        const cv817 = v817;
        const cv818 = v818;
        const cv819 = v819;
        const cv820 = true;
        const cv821 = v944;
        const cv824 = v945;
        const cv827 = v827;
        const cv828 = v828;
        const cv829 = v829;
        
        v817 = cv817;
        v818 = cv818;
        v819 = cv819;
        v820 = cv820;
        v821 = cv821;
        v824 = cv824;
        v827 = cv827;
        v828 = cv828;
        v829 = cv829;
        
        continue;
        break;
        }
      }
    
    }
  const v1394 = stdlib.add(v817, v772);
  const v1395 = stdlib.div(v817, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
  const v1396 = stdlib.mul(v1395, v773);
  const v1397 = stdlib.add(v817, v1396);
  const v1398 = stdlib.gt(v1394, v1397);
  const v1399 = v1398 ? v1394 : v1397;
  const v1401 = stdlib.div(v829, stdlib.checkedBigNumberify('./token.rsh:273:34:decimal', stdlib.UInt_max, 100));
  const v1402 = stdlib.mul(v769, v1401);
  const v1404 = stdlib.add(v1402, v1401);
  const v1405 = stdlib.sub(v829, v1404);
  const v1406 = stdlib.ge(v817, v770);
  if (v1406) {
    const v1411 = stdlib.sub(v828, v828);
    ;
    const v1415 = stdlib.sub(v829, v1405);
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 4,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1419, time: v1418, didSend: v683, from: v1417 } = txn4;
    ;
    const v1421 = stdlib.addressEq(v740, v1417);
    stdlib.assert(v1421, {
      at: './token.rsh:311:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Auctioneer'
      });
    if (v1406) {
      const v1425 = stdlib.sub(v1415, v1402);
      ;
      const v1429 = stdlib.sub(v1425, v1401);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  else {
    const v1474 = stdlib.add(v1405, v1402);
    const v1475 = stdlib.add(v1474, v1401);
    const v1479 = stdlib.sub(v829, v1475);
    ;
    const v1484 = stdlib.sub(v828, v828);
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 5,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1488, time: v1487, didSend: v683, from: v1486 } = txn4;
    ;
    const v1490 = stdlib.addressEq(v740, v1486);
    stdlib.assert(v1490, {
      at: './token.rsh:311:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Auctioneer'
      });
    if (v1406) {
      const v1494 = stdlib.sub(v1479, v1402);
      ;
      const v1498 = stdlib.sub(v1494, v1401);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  
  
  
  
  
  };
export async function Bid_close(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_close expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_close expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_close0_161: ctc4,
    Bid_getBid0_161: ctc5,
    Bid_getPurchase0_161: ctc5,
    Bid_touch0_161: ctc4
    });
  
  
  const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10), [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]);
  const v892 = stdlib.protect(ctc4, await interact.in(), {
    at: './token.rsh:1:23:application',
    fs: ['at ./token.rsh:252:11:application call to [unknown function] (defined at: ./token.rsh:252:11:function exp)', 'at ./token.rsh:167:19:application call to "runBid_close0_161" (defined at: ./token.rsh:252:11:function exp)', 'at ./token.rsh:167:19:application call to [unknown function] (defined at: ./token.rsh:167:19:function exp)'],
    msg: 'in',
    who: 'Bid_close'
    });
  
  const v898 = ['Bid_close0_161', v892];
  
  const txn1 = await (ctc.sendrecv({
    args: [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849, v898],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./token.rsh:253:18:decimal', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./token.rsh:253:22:decimal', stdlib.UInt_max, 0), v777]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v943], secs: v945, time: v944, didSend: v565, from: v942 } = txn1;
      
      switch (v943[0]) {
        case 'Bid_close0_161': {
          const v946 = v943[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./token.rsh:253:18:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./token.rsh:253:22:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: v777
            });
          undefined;
          const v995 = null;
          const v996 = await txn1.getOutput('Bid_close', 'v995', ctc3, v995);
          
          const v1002 = stdlib.lt(v824, v818);
          const v2493 = v817;
          const v2494 = v818;
          const v2495 = v819;
          const v2498 = v945;
          const v2499 = v827;
          const v2500 = v828;
          const v2501 = v829;
          if (v1002) {
            const v2502 = stdlib.add(v817, v772);
            const v2503 = stdlib.div(v817, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
            const v2504 = stdlib.mul(v2503, v773);
            const v2505 = stdlib.add(v817, v2504);
            const v2506 = stdlib.gt(v2502, v2505);
            const v2507 = v2506 ? v2502 : v2505;
            sim_r.isHalt = false;
            }
          else {
            const v2508 = stdlib.add(v817, v772);
            const v2509 = stdlib.div(v817, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
            const v2510 = stdlib.mul(v2509, v773);
            const v2511 = stdlib.add(v817, v2510);
            const v2512 = stdlib.gt(v2508, v2511);
            const v2513 = v2512 ? v2508 : v2511;
            const v2514 = stdlib.div(v829, stdlib.checkedBigNumberify('./token.rsh:273:34:decimal', stdlib.UInt_max, 100));
            const v2515 = stdlib.mul(v769, v2514);
            const v2516 = stdlib.add(v2515, v2514);
            const v2517 = stdlib.sub(v829, v2516);
            const v2518 = stdlib.ge(v817, v770);
            if (v2518) {
              const v2519 = stdlib.sub(v828, v828);
              sim_r.txns.push({
                amt: v828,
                kind: 'from',
                to: v819,
                tok: v776
                });
              const v2520 = stdlib.sub(v829, v2517);
              sim_r.txns.push({
                amt: v2517,
                kind: 'from',
                to: v767,
                tok: v777
                });
              sim_r.isHalt = false;
              }
            else {
              const v2528 = stdlib.add(v2517, v2515);
              const v2529 = stdlib.add(v2528, v2514);
              const v2530 = stdlib.sub(v829, v2529);
              sim_r.txns.push({
                amt: v2529,
                kind: 'from',
                to: v819,
                tok: v777
                });
              const v2531 = stdlib.sub(v828, v828);
              sim_r.txns.push({
                amt: v828,
                kind: 'from',
                to: v767,
                tok: v776
                });
              sim_r.isHalt = false;
              }}
          break;
          }
        case 'Bid_getBid0_161': {
          const v1058 = v943[1];
          
          break;
          }
        case 'Bid_getPurchase0_161': {
          const v1170 = v943[1];
          
          break;
          }
        case 'Bid_touch0_161': {
          const v1282 = v943[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v943], secs: v945, time: v944, didSend: v565, from: v942 } = txn1;
  switch (v943[0]) {
    case 'Bid_close0_161': {
      const v946 = v943[1];
      ;
      ;
      undefined;
      const v995 = null;
      const v996 = await txn1.getOutput('Bid_close', 'v995', ctc3, v995);
      if (v565) {
        stdlib.protect(ctc3, await interact.out(v946, v996), {
          at: './token.rsh:252:12:application',
          fs: ['at ./token.rsh:252:12:application call to [unknown function] (defined at: ./token.rsh:252:12:function exp)', 'at ./token.rsh:255:12:application call to "k" (defined at: ./token.rsh:254:9:function exp)', 'at ./token.rsh:254:9:application call to [unknown function] (defined at: ./token.rsh:254:9:function exp)'],
          msg: 'out',
          who: 'Bid_close'
          });
        }
      else {
        }
      
      const v1002 = stdlib.lt(v824, v818);
      const v2493 = v817;
      const v2494 = v818;
      const v2495 = v819;
      const v2498 = v945;
      const v2499 = v827;
      const v2500 = v828;
      const v2501 = v829;
      if (v1002) {
        const v2502 = stdlib.add(v817, v772);
        const v2503 = stdlib.div(v817, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
        const v2504 = stdlib.mul(v2503, v773);
        const v2505 = stdlib.add(v817, v2504);
        const v2506 = stdlib.gt(v2502, v2505);
        const v2507 = v2506 ? v2502 : v2505;
        return;
        }
      else {
        const v2508 = stdlib.add(v817, v772);
        const v2509 = stdlib.div(v817, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
        const v2510 = stdlib.mul(v2509, v773);
        const v2511 = stdlib.add(v817, v2510);
        const v2512 = stdlib.gt(v2508, v2511);
        const v2513 = v2512 ? v2508 : v2511;
        const v2514 = stdlib.div(v829, stdlib.checkedBigNumberify('./token.rsh:273:34:decimal', stdlib.UInt_max, 100));
        const v2515 = stdlib.mul(v769, v2514);
        const v2516 = stdlib.add(v2515, v2514);
        const v2517 = stdlib.sub(v829, v2516);
        const v2518 = stdlib.ge(v817, v770);
        if (v2518) {
          const v2519 = stdlib.sub(v828, v828);
          ;
          const v2520 = stdlib.sub(v829, v2517);
          ;
          return;
          }
        else {
          const v2528 = stdlib.add(v2517, v2515);
          const v2529 = stdlib.add(v2528, v2514);
          const v2530 = stdlib.sub(v829, v2529);
          ;
          const v2531 = stdlib.sub(v828, v828);
          ;
          return;
          }}
      break;
      }
    case 'Bid_getBid0_161': {
      const v1058 = v943[1];
      return;
      break;
      }
    case 'Bid_getPurchase0_161': {
      const v1170 = v943[1];
      return;
      break;
      }
    case 'Bid_touch0_161': {
      const v1282 = v943[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_getBid(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_getBid expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_getBid expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Tuple([ctc1]);
  const ctc4 = stdlib.T_Null;
  const ctc5 = stdlib.T_Tuple([ctc4]);
  const ctc6 = stdlib.T_Data({
    Bid_close0_161: ctc5,
    Bid_getBid0_161: ctc3,
    Bid_getPurchase0_161: ctc3,
    Bid_touch0_161: ctc5
    });
  
  
  const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10), [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]);
  const v860 = stdlib.protect(ctc3, await interact.in(), {
    at: './token.rsh:1:23:application',
    fs: ['at ./token.rsh:203:9:application call to [unknown function] (defined at: ./token.rsh:203:9:function exp)', 'at ./token.rsh:167:19:application call to "runBid_getBid0_161" (defined at: ./token.rsh:202:11:function exp)', 'at ./token.rsh:167:19:application call to [unknown function] (defined at: ./token.rsh:167:19:function exp)'],
    msg: 'in',
    who: 'Bid_getBid'
    });
  const v861 = v860[stdlib.checkedBigNumberify('./token.rsh:202:11:spread', stdlib.UInt_max, 0)];
  const v863 = stdlib.lt(v824, v818);
  const v870 = stdlib.ge(v861, v849);
  const v871 = v863 ? v870 : false;
  const v872 = stdlib.ge(v861, v771);
  const v873 = v871 ? v872 : false;
  stdlib.assert(v873, {
    at: './token.rsh:203:25:application',
    fs: ['at ./token.rsh:203:9:application call to [unknown function] (defined at: ./token.rsh:203:16:function exp)', 'at ./token.rsh:203:9:application call to [unknown function] (defined at: ./token.rsh:203:9:function exp)', 'at ./token.rsh:167:19:application call to "runBid_getBid0_161" (defined at: ./token.rsh:202:11:function exp)', 'at ./token.rsh:167:19:application call to [unknown function] (defined at: ./token.rsh:167:19:function exp)'],
    msg: null,
    who: 'Bid_getBid'
    });
  
  const v909 = ['Bid_getBid0_161', v860];
  
  const txn1 = await (ctc.sendrecv({
    args: [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849, v909],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./token.rsh:207:20:decimal', stdlib.UInt_max, 0), [[v861, v777]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v943], secs: v945, time: v944, didSend: v565, from: v942 } = txn1;
      
      switch (v943[0]) {
        case 'Bid_close0_161': {
          const v946 = v943[1];
          
          break;
          }
        case 'Bid_getBid0_161': {
          const v1058 = v943[1];
          const v1071 = v1058[stdlib.checkedBigNumberify('./token.rsh:202:11:spread', stdlib.UInt_max, 0)];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./token.rsh:207:20:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          const v1104 = stdlib.add(v829, v1071);
          sim_r.txns.push({
            amt: v1071,
            kind: 'to',
            tok: v777
            });
          undefined;
          const v1126 = stdlib.ge(v1071, v849);
          const v1127 = v863 ? v1126 : false;
          const v1128 = stdlib.ge(v1071, v771);
          const v1129 = v1127 ? v1128 : false;
          stdlib.assert(v1129, {
            at: './token.rsh:209:18:application',
            fs: ['at ./token.rsh:208:9:application call to [unknown function] (defined at: ./token.rsh:208:9:function exp)'],
            msg: null,
            who: 'Bid_getBid'
            });
          const v1133 = stdlib.sub(v1104, v817);
          sim_r.txns.push({
            amt: v817,
            kind: 'from',
            to: v819,
            tok: v777
            });
          const v1134 = null;
          const v1135 = await txn1.getOutput('Bid_getBid', 'v1134', ctc4, v1134);
          
          const v1140 = stdlib.add(v818, stdlib.checkedBigNumberify('./token.rsh:158:33:decimal', stdlib.UInt_max, 60));
          const v2723 = v1071;
          const v2724 = v1140;
          const v2725 = v942;
          const v2728 = v945;
          const v2729 = v827;
          const v2730 = v828;
          const v2731 = v1133;
          const v2732 = stdlib.add(v1071, v772);
          const v2733 = stdlib.div(v1071, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
          const v2734 = stdlib.mul(v2733, v773);
          const v2735 = stdlib.add(v1071, v2734);
          const v2736 = stdlib.gt(v2732, v2735);
          const v2737 = v2736 ? v2732 : v2735;
          sim_r.isHalt = false;
          
          break;
          }
        case 'Bid_getPurchase0_161': {
          const v1170 = v943[1];
          
          break;
          }
        case 'Bid_touch0_161': {
          const v1282 = v943[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v943], secs: v945, time: v944, didSend: v565, from: v942 } = txn1;
  switch (v943[0]) {
    case 'Bid_close0_161': {
      const v946 = v943[1];
      return;
      break;
      }
    case 'Bid_getBid0_161': {
      const v1058 = v943[1];
      const v1071 = v1058[stdlib.checkedBigNumberify('./token.rsh:202:11:spread', stdlib.UInt_max, 0)];
      ;
      const v1104 = stdlib.add(v829, v1071);
      ;
      undefined;
      const v1126 = stdlib.ge(v1071, v849);
      const v1127 = v863 ? v1126 : false;
      const v1128 = stdlib.ge(v1071, v771);
      const v1129 = v1127 ? v1128 : false;
      stdlib.assert(v1129, {
        at: './token.rsh:209:18:application',
        fs: ['at ./token.rsh:208:9:application call to [unknown function] (defined at: ./token.rsh:208:9:function exp)'],
        msg: null,
        who: 'Bid_getBid'
        });
      const v1133 = stdlib.sub(v1104, v817);
      ;
      const v1134 = null;
      const v1135 = await txn1.getOutput('Bid_getBid', 'v1134', ctc4, v1134);
      if (v565) {
        stdlib.protect(ctc4, await interact.out(v1058, v1135), {
          at: './token.rsh:202:12:application',
          fs: ['at ./token.rsh:202:12:application call to [unknown function] (defined at: ./token.rsh:202:12:function exp)', 'at ./token.rsh:214:12:application call to "k" (defined at: ./token.rsh:208:9:function exp)', 'at ./token.rsh:208:9:application call to [unknown function] (defined at: ./token.rsh:208:9:function exp)'],
          msg: 'out',
          who: 'Bid_getBid'
          });
        }
      else {
        }
      
      const v1140 = stdlib.add(v818, stdlib.checkedBigNumberify('./token.rsh:158:33:decimal', stdlib.UInt_max, 60));
      const v2723 = v1071;
      const v2724 = v1140;
      const v2725 = v942;
      const v2728 = v945;
      const v2729 = v827;
      const v2730 = v828;
      const v2731 = v1133;
      const v2732 = stdlib.add(v1071, v772);
      const v2733 = stdlib.div(v1071, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
      const v2734 = stdlib.mul(v2733, v773);
      const v2735 = stdlib.add(v1071, v2734);
      const v2736 = stdlib.gt(v2732, v2735);
      const v2737 = v2736 ? v2732 : v2735;
      return;
      
      break;
      }
    case 'Bid_getPurchase0_161': {
      const v1170 = v943[1];
      return;
      break;
      }
    case 'Bid_touch0_161': {
      const v1282 = v943[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_getPurchase(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_getPurchase expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_getPurchase expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Tuple([ctc1]);
  const ctc4 = stdlib.T_Null;
  const ctc5 = stdlib.T_Tuple([ctc4]);
  const ctc6 = stdlib.T_Data({
    Bid_close0_161: ctc5,
    Bid_getBid0_161: ctc3,
    Bid_getPurchase0_161: ctc3,
    Bid_touch0_161: ctc5
    });
  
  
  const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10), [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]);
  const v879 = stdlib.protect(ctc3, await interact.in(), {
    at: './token.rsh:1:23:application',
    fs: ['at ./token.rsh:228:9:application call to [unknown function] (defined at: ./token.rsh:228:9:function exp)', 'at ./token.rsh:167:19:application call to "runBid_getPurchase0_161" (defined at: ./token.rsh:227:11:function exp)', 'at ./token.rsh:167:19:application call to [unknown function] (defined at: ./token.rsh:167:19:function exp)'],
    msg: 'in',
    who: 'Bid_getPurchase'
    });
  const v880 = v879[stdlib.checkedBigNumberify('./token.rsh:227:11:spread', stdlib.UInt_max, 0)];
  const v882 = stdlib.ge(v824, v818);
  const v883 = stdlib.lt(v817, v770);
  const v884 = v882 ? v883 : false;
  const v885 = stdlib.ge(v880, v770);
  const v886 = v884 ? v885 : false;
  stdlib.assert(v886, {
    at: './token.rsh:228:25:application',
    fs: ['at ./token.rsh:228:9:application call to [unknown function] (defined at: ./token.rsh:228:16:function exp)', 'at ./token.rsh:228:9:application call to [unknown function] (defined at: ./token.rsh:228:9:function exp)', 'at ./token.rsh:167:19:application call to "runBid_getPurchase0_161" (defined at: ./token.rsh:227:11:function exp)', 'at ./token.rsh:167:19:application call to [unknown function] (defined at: ./token.rsh:167:19:function exp)'],
    msg: null,
    who: 'Bid_getPurchase'
    });
  
  const v920 = ['Bid_getPurchase0_161', v879];
  
  const txn1 = await (ctc.sendrecv({
    args: [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849, v920],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./token.rsh:233:20:decimal', stdlib.UInt_max, 0), [[v880, v777]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v943], secs: v945, time: v944, didSend: v565, from: v942 } = txn1;
      
      switch (v943[0]) {
        case 'Bid_close0_161': {
          const v946 = v943[1];
          
          break;
          }
        case 'Bid_getBid0_161': {
          const v1058 = v943[1];
          
          break;
          }
        case 'Bid_getPurchase0_161': {
          const v1170 = v943[1];
          const v1191 = v1170[stdlib.checkedBigNumberify('./token.rsh:227:11:spread', stdlib.UInt_max, 0)];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./token.rsh:233:20:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          const v1216 = stdlib.add(v829, v1191);
          sim_r.txns.push({
            amt: v1191,
            kind: 'to',
            tok: v777
            });
          undefined;
          const v1260 = stdlib.ge(v1191, v770);
          const v1261 = v884 ? v1260 : false;
          stdlib.assert(v1261, {
            at: './token.rsh:235:18:application',
            fs: ['at ./token.rsh:234:9:application call to [unknown function] (defined at: ./token.rsh:234:9:function exp)'],
            msg: null,
            who: 'Bid_getPurchase'
            });
          const v1265 = stdlib.sub(v1216, v817);
          sim_r.txns.push({
            amt: v817,
            kind: 'from',
            to: v819,
            tok: v777
            });
          const v1266 = null;
          const v1267 = await txn1.getOutput('Bid_getPurchase', 'v1266', ctc4, v1266);
          
          const v2953 = v1191;
          const v2954 = v818;
          const v2955 = v942;
          const v2959 = v827;
          const v2968 = stdlib.add(v1191, v772);
          const v2969 = stdlib.div(v1191, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
          const v2970 = stdlib.mul(v2969, v773);
          const v2971 = stdlib.add(v1191, v2970);
          const v2972 = stdlib.gt(v2968, v2971);
          const v2973 = v2972 ? v2968 : v2971;
          const v2974 = stdlib.div(v1265, stdlib.checkedBigNumberify('./token.rsh:273:34:decimal', stdlib.UInt_max, 100));
          const v2975 = stdlib.mul(v769, v2974);
          const v2976 = stdlib.add(v2975, v2974);
          const v2977 = stdlib.sub(v1265, v2976);
          if (v1260) {
            const v2979 = stdlib.sub(v828, v828);
            sim_r.txns.push({
              amt: v828,
              kind: 'from',
              to: v942,
              tok: v776
              });
            const v2980 = stdlib.sub(v1265, v2977);
            sim_r.txns.push({
              amt: v2977,
              kind: 'from',
              to: v767,
              tok: v777
              });
            sim_r.isHalt = false;
            }
          else {
            const v2988 = stdlib.add(v2977, v2975);
            const v2989 = stdlib.add(v2988, v2974);
            const v2990 = stdlib.sub(v1265, v2989);
            sim_r.txns.push({
              amt: v2989,
              kind: 'from',
              to: v942,
              tok: v777
              });
            const v2991 = stdlib.sub(v828, v828);
            sim_r.txns.push({
              amt: v828,
              kind: 'from',
              to: v767,
              tok: v776
              });
            sim_r.isHalt = false;
            }
          break;
          }
        case 'Bid_touch0_161': {
          const v1282 = v943[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v943], secs: v945, time: v944, didSend: v565, from: v942 } = txn1;
  switch (v943[0]) {
    case 'Bid_close0_161': {
      const v946 = v943[1];
      return;
      break;
      }
    case 'Bid_getBid0_161': {
      const v1058 = v943[1];
      return;
      break;
      }
    case 'Bid_getPurchase0_161': {
      const v1170 = v943[1];
      const v1191 = v1170[stdlib.checkedBigNumberify('./token.rsh:227:11:spread', stdlib.UInt_max, 0)];
      ;
      const v1216 = stdlib.add(v829, v1191);
      ;
      undefined;
      const v1260 = stdlib.ge(v1191, v770);
      const v1261 = v884 ? v1260 : false;
      stdlib.assert(v1261, {
        at: './token.rsh:235:18:application',
        fs: ['at ./token.rsh:234:9:application call to [unknown function] (defined at: ./token.rsh:234:9:function exp)'],
        msg: null,
        who: 'Bid_getPurchase'
        });
      const v1265 = stdlib.sub(v1216, v817);
      ;
      const v1266 = null;
      const v1267 = await txn1.getOutput('Bid_getPurchase', 'v1266', ctc4, v1266);
      if (v565) {
        stdlib.protect(ctc4, await interact.out(v1170, v1267), {
          at: './token.rsh:227:12:application',
          fs: ['at ./token.rsh:227:12:application call to [unknown function] (defined at: ./token.rsh:227:12:function exp)', 'at ./token.rsh:241:12:application call to "k" (defined at: ./token.rsh:234:9:function exp)', 'at ./token.rsh:234:9:application call to [unknown function] (defined at: ./token.rsh:234:9:function exp)'],
          msg: 'out',
          who: 'Bid_getPurchase'
          });
        }
      else {
        }
      
      const v2953 = v1191;
      const v2954 = v818;
      const v2955 = v942;
      const v2959 = v827;
      const v2968 = stdlib.add(v1191, v772);
      const v2969 = stdlib.div(v1191, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
      const v2970 = stdlib.mul(v2969, v773);
      const v2971 = stdlib.add(v1191, v2970);
      const v2972 = stdlib.gt(v2968, v2971);
      const v2973 = v2972 ? v2968 : v2971;
      const v2974 = stdlib.div(v1265, stdlib.checkedBigNumberify('./token.rsh:273:34:decimal', stdlib.UInt_max, 100));
      const v2975 = stdlib.mul(v769, v2974);
      const v2976 = stdlib.add(v2975, v2974);
      const v2977 = stdlib.sub(v1265, v2976);
      if (v1260) {
        const v2979 = stdlib.sub(v828, v828);
        ;
        const v2980 = stdlib.sub(v1265, v2977);
        ;
        return;
        }
      else {
        const v2988 = stdlib.add(v2977, v2975);
        const v2989 = stdlib.add(v2988, v2974);
        const v2990 = stdlib.sub(v1265, v2989);
        ;
        const v2991 = stdlib.sub(v828, v828);
        ;
        return;
        }
      break;
      }
    case 'Bid_touch0_161': {
      const v1282 = v943[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_touch(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_touch expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_touch expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_close0_161: ctc4,
    Bid_getBid0_161: ctc5,
    Bid_getPurchase0_161: ctc5,
    Bid_touch0_161: ctc4
    });
  
  
  const [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10), [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]);
  const v852 = stdlib.protect(ctc4, await interact.in(), {
    at: './token.rsh:1:23:application',
    fs: ['at ./token.rsh:186:11:application call to [unknown function] (defined at: ./token.rsh:186:11:function exp)', 'at ./token.rsh:167:19:application call to "runBid_touch0_161" (defined at: ./token.rsh:186:11:function exp)', 'at ./token.rsh:167:19:application call to [unknown function] (defined at: ./token.rsh:167:19:function exp)'],
    msg: 'in',
    who: 'Bid_touch'
    });
  
  const v931 = ['Bid_touch0_161', v852];
  
  const txn1 = await (ctc.sendrecv({
    args: [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v817, v818, v819, v824, v827, v828, v829, v849, v931],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./token.rsh:187:18:decimal', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./token.rsh:187:22:decimal', stdlib.UInt_max, 0), v777]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v943], secs: v945, time: v944, didSend: v565, from: v942 } = txn1;
      
      switch (v943[0]) {
        case 'Bid_close0_161': {
          const v946 = v943[1];
          
          break;
          }
        case 'Bid_getBid0_161': {
          const v1058 = v943[1];
          
          break;
          }
        case 'Bid_getPurchase0_161': {
          const v1170 = v943[1];
          
          break;
          }
        case 'Bid_touch0_161': {
          const v1282 = v943[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./token.rsh:187:18:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./token.rsh:187:22:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: v777
            });
          undefined;
          const v1387 = null;
          const v1388 = await txn1.getOutput('Bid_touch', 'v1387', ctc3, v1387);
          
          const v3183 = v817;
          const v3184 = v818;
          const v3185 = v819;
          const v3188 = v945;
          const v3189 = v827;
          const v3190 = v828;
          const v3191 = v829;
          const v3192 = stdlib.add(v817, v772);
          const v3193 = stdlib.div(v817, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
          const v3194 = stdlib.mul(v3193, v773);
          const v3195 = stdlib.add(v817, v3194);
          const v3196 = stdlib.gt(v3192, v3195);
          const v3197 = v3196 ? v3192 : v3195;
          sim_r.isHalt = false;
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v943], secs: v945, time: v944, didSend: v565, from: v942 } = txn1;
  switch (v943[0]) {
    case 'Bid_close0_161': {
      const v946 = v943[1];
      return;
      break;
      }
    case 'Bid_getBid0_161': {
      const v1058 = v943[1];
      return;
      break;
      }
    case 'Bid_getPurchase0_161': {
      const v1170 = v943[1];
      return;
      break;
      }
    case 'Bid_touch0_161': {
      const v1282 = v943[1];
      ;
      ;
      undefined;
      const v1387 = null;
      const v1388 = await txn1.getOutput('Bid_touch', 'v1387', ctc3, v1387);
      if (v565) {
        stdlib.protect(ctc3, await interact.out(v1282, v1388), {
          at: './token.rsh:186:12:application',
          fs: ['at ./token.rsh:186:12:application call to [unknown function] (defined at: ./token.rsh:186:12:function exp)', 'at ./token.rsh:189:12:application call to "k" (defined at: ./token.rsh:188:9:function exp)', 'at ./token.rsh:188:9:application call to [unknown function] (defined at: ./token.rsh:188:9:function exp)'],
          msg: 'out',
          who: 'Bid_touch'
          });
        }
      else {
        }
      
      const v3183 = v817;
      const v3184 = v818;
      const v3185 = v819;
      const v3188 = v945;
      const v3189 = v827;
      const v3190 = v828;
      const v3191 = v829;
      const v3192 = stdlib.add(v817, v772);
      const v3193 = stdlib.div(v817, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
      const v3194 = stdlib.mul(v3193, v773);
      const v3195 = stdlib.add(v817, v3194);
      const v3196 = stdlib.gt(v3192, v3195);
      const v3197 = v3196 ? v3192 : v3195;
      return;
      
      break;
      }
    }
  
  
  };
export async function Constructor(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Constructor expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Constructor expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_Object({
    addr: ctc0,
    addr2: ctc0,
    addr3: ctc0,
    addr4: ctc0
    });
  const ctc2 = stdlib.T_Null;
  const ctc3 = stdlib.T_UInt;
  const ctc4 = stdlib.T_Token;
  const ctc5 = stdlib.T_Tuple([ctc2]);
  const ctc6 = stdlib.T_Tuple([ctc3]);
  const ctc7 = stdlib.T_Data({
    Bid_close0_161: ctc5,
    Bid_getBid0_161: ctc6,
    Bid_getPurchase0_161: ctc6,
    Bid_touch0_161: ctc5
    });
  
  
  const v727 = stdlib.protect(ctc1, await interact.getParams(), {
    at: './util.rsh:43:38:application',
    fs: ['at ./util.rsh:37:19:application call to [unknown function] (defined at: ./util.rsh:37:23:function exp)', 'at ./token.rsh:75:50:application call to "construct" (defined at: ./util.rsh:36:47:function exp)'],
    msg: 'getParams',
    who: 'Constructor'
    });
  const v728 = v727.addr;
  const v729 = v727.addr2;
  const v730 = v727.addr3;
  const v731 = v727.addr4;
  
  const txn1 = await (ctc.sendrecv({
    args: [v728, v729, v730, v731],
    evt_cnt: 4,
    funcNum: 0,
    lct: stdlib.checkedBigNumberify('./util.rsh:47:6:dot', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    pay: [stdlib.checkedBigNumberify('./util.rsh:47:6:decimal', stdlib.UInt_max, 0), []],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v733, v734, v735, v736], secs: v738, time: v737, didSend: v36, from: v732 } = txn1;
      
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./util.rsh:47:6:decimal', stdlib.UInt_max, 0),
        kind: 'to',
        tok: undefined
        });
      const v740 = v736;
      sim_r.isHalt = false;
      
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0],
    waitIfNotPresent: false
    }));
  const {data: [v733, v734, v735, v736], secs: v738, time: v737, didSend: v36, from: v732 } = txn1;
  ;
  const v740 = v736;
  stdlib.protect(ctc2, await interact.signal(), {
    at: './util.rsh:55:41:application',
    fs: ['at ./util.rsh:55:19:application call to [unknown function] (defined at: ./util.rsh:55:23:function exp)', 'at ./token.rsh:75:50:application call to "construct" (defined at: ./util.rsh:36:47:function exp)'],
    msg: 'signal',
    who: 'Constructor'
    });
  
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 13,
    funcNum: 1,
    out_tys: [ctc0, ctc3, ctc3, ctc3, ctc3, ctc3, ctc3, ctc3, ctc4, ctc4, ctc3, ctc3, ctc3],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v768, v769, v770, v771, v772, v773, v774, v775, v776, v777, v778, v779, v780], secs: v782, time: v781, didSend: v87, from: v767 } = txn2;
  const v783 = stdlib.tokenEq(v776, v777);
  const v784 = v783 ? false : true;
  stdlib.assert(v784, {
    at: './token.rsh:103:6:dot',
    fs: [],
    msg: 'non-network tokens distinct',
    who: 'Constructor'
    });
  ;
  ;
  ;
  stdlib.assert(v784, {
    at: './token.rsh:120:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v789 = stdlib.ge(v769, stdlib.checkedBigNumberify('./token.rsh:121:27:decimal', stdlib.UInt_max, 0));
  const v790 = stdlib.le(v769, stdlib.checkedBigNumberify('./token.rsh:121:48:decimal', stdlib.UInt_max, 99));
  const v791 = v789 ? v790 : false;
  stdlib.assert(v791, {
    at: './token.rsh:121:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v792 = stdlib.ge(v771, stdlib.checkedBigNumberify('./token.rsh:122:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v792, {
    at: './token.rsh:122:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v793 = stdlib.lt(v771, v770);
  stdlib.assert(v793, {
    at: './token.rsh:123:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v797 = stdlib.sub(stdlib.checkedBigNumberify('./token.rsh:119:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./token.rsh:126:12:decimal', stdlib.UInt_max, 20000));
  ;
  const v801 = stdlib.sub(v797, stdlib.checkedBigNumberify('./token.rsh:127:12:decimal', stdlib.UInt_max, 30000));
  ;
  const v805 = stdlib.sub(v801, stdlib.checkedBigNumberify('./token.rsh:128:12:decimal', stdlib.UInt_max, 50000));
  ;
  const v806 = v767;
  const txn3 = await (ctc.recv({
    didSend: false,
    evt_cnt: 0,
    funcNum: 2,
    out_tys: [],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [], secs: v809, time: v808, didSend: v116, from: v807 } = txn3;
  ;
  ;
  const v813 = stdlib.addressEq(v806, v807);
  stdlib.assert(v813, {
    at: './token.rsh:134:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Constructor'
    });
  let v817 = stdlib.checkedBigNumberify('./token.rsh:170:24:decimal', stdlib.UInt_max, 0);
  let v818 = v780;
  let v819 = v767;
  let v820 = true;
  let v821 = v808;
  let v824 = v809;
  let v827 = v805;
  let v828 = stdlib.checkedBigNumberify('./token.rsh:134:15:decimal', stdlib.UInt_max, 1);
  let v829 = stdlib.checkedBigNumberify('./token.rsh:103:6:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    
    return v820;})()) {
    const v844 = stdlib.add(v817, v772);
    const v845 = stdlib.div(v817, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
    const v846 = stdlib.mul(v845, v773);
    const v847 = stdlib.add(v817, v846);
    const v848 = stdlib.gt(v844, v847);
    const v849 = v848 ? v844 : v847;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc7],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v943], secs: v945, time: v944, didSend: v565, from: v942 } = txn4;
    switch (v943[0]) {
      case 'Bid_close0_161': {
        const v946 = v943[1];
        ;
        ;
        undefined;
        const v995 = null;
        await txn4.getOutput('Bid_close', 'v995', ctc2, v995);
        const v1002 = stdlib.lt(v824, v818);
        const cv817 = v817;
        const cv818 = v818;
        const cv819 = v819;
        const cv820 = v1002;
        const cv821 = v944;
        const cv824 = v945;
        const cv827 = v827;
        const cv828 = v828;
        const cv829 = v829;
        
        v817 = cv817;
        v818 = cv818;
        v819 = cv819;
        v820 = cv820;
        v821 = cv821;
        v824 = cv824;
        v827 = cv827;
        v828 = cv828;
        v829 = cv829;
        
        continue;
        break;
        }
      case 'Bid_getBid0_161': {
        const v1058 = v943[1];
        const v1071 = v1058[stdlib.checkedBigNumberify('./token.rsh:202:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1104 = stdlib.add(v829, v1071);
        ;
        undefined;
        const v1119 = stdlib.lt(v824, v818);
        const v1126 = stdlib.ge(v1071, v849);
        const v1127 = v1119 ? v1126 : false;
        const v1128 = stdlib.ge(v1071, v771);
        const v1129 = v1127 ? v1128 : false;
        stdlib.assert(v1129, {
          at: './token.rsh:209:18:application',
          fs: ['at ./token.rsh:208:9:application call to [unknown function] (defined at: ./token.rsh:208:9:function exp)'],
          msg: null,
          who: 'Constructor'
          });
        const v1133 = stdlib.sub(v1104, v817);
        ;
        const v1134 = null;
        await txn4.getOutput('Bid_getBid', 'v1134', ctc2, v1134);
        const v1140 = stdlib.add(v818, stdlib.checkedBigNumberify('./token.rsh:158:33:decimal', stdlib.UInt_max, 60));
        const cv817 = v1071;
        const cv818 = v1140;
        const cv819 = v942;
        const cv820 = true;
        const cv821 = v944;
        const cv824 = v945;
        const cv827 = v827;
        const cv828 = v828;
        const cv829 = v1133;
        
        v817 = cv817;
        v818 = cv818;
        v819 = cv819;
        v820 = cv820;
        v821 = cv821;
        v824 = cv824;
        v827 = cv827;
        v828 = cv828;
        v829 = cv829;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0_161': {
        const v1170 = v943[1];
        const v1191 = v1170[stdlib.checkedBigNumberify('./token.rsh:227:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1216 = stdlib.add(v829, v1191);
        ;
        undefined;
        const v1257 = stdlib.ge(v824, v818);
        const v1258 = stdlib.lt(v817, v770);
        const v1259 = v1257 ? v1258 : false;
        const v1260 = stdlib.ge(v1191, v770);
        const v1261 = v1259 ? v1260 : false;
        stdlib.assert(v1261, {
          at: './token.rsh:235:18:application',
          fs: ['at ./token.rsh:234:9:application call to [unknown function] (defined at: ./token.rsh:234:9:function exp)'],
          msg: null,
          who: 'Constructor'
          });
        const v1265 = stdlib.sub(v1216, v817);
        ;
        const v1266 = null;
        await txn4.getOutput('Bid_getPurchase', 'v1266', ctc2, v1266);
        const cv817 = v1191;
        const cv818 = v818;
        const cv819 = v942;
        const cv820 = false;
        const cv821 = v944;
        const cv824 = v945;
        const cv827 = v827;
        const cv828 = v828;
        const cv829 = v1265;
        
        v817 = cv817;
        v818 = cv818;
        v819 = cv819;
        v820 = cv820;
        v821 = cv821;
        v824 = cv824;
        v827 = cv827;
        v828 = cv828;
        v829 = cv829;
        
        continue;
        break;
        }
      case 'Bid_touch0_161': {
        const v1282 = v943[1];
        ;
        ;
        undefined;
        const v1387 = null;
        await txn4.getOutput('Bid_touch', 'v1387', ctc2, v1387);
        const cv817 = v817;
        const cv818 = v818;
        const cv819 = v819;
        const cv820 = true;
        const cv821 = v944;
        const cv824 = v945;
        const cv827 = v827;
        const cv828 = v828;
        const cv829 = v829;
        
        v817 = cv817;
        v818 = cv818;
        v819 = cv819;
        v820 = cv820;
        v821 = cv821;
        v824 = cv824;
        v827 = cv827;
        v828 = cv828;
        v829 = cv829;
        
        continue;
        break;
        }
      }
    
    }
  const v1394 = stdlib.add(v817, v772);
  const v1395 = stdlib.div(v817, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
  const v1396 = stdlib.mul(v1395, v773);
  const v1397 = stdlib.add(v817, v1396);
  const v1398 = stdlib.gt(v1394, v1397);
  const v1399 = v1398 ? v1394 : v1397;
  const v1401 = stdlib.div(v829, stdlib.checkedBigNumberify('./token.rsh:273:34:decimal', stdlib.UInt_max, 100));
  const v1402 = stdlib.mul(v769, v1401);
  const v1404 = stdlib.add(v1402, v1401);
  const v1405 = stdlib.sub(v829, v1404);
  const v1406 = stdlib.ge(v817, v770);
  if (v1406) {
    const v1411 = stdlib.sub(v828, v828);
    ;
    const v1415 = stdlib.sub(v829, v1405);
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 4,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1419, time: v1418, didSend: v683, from: v1417 } = txn4;
    ;
    const v1421 = stdlib.addressEq(v740, v1417);
    stdlib.assert(v1421, {
      at: './token.rsh:311:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Constructor'
      });
    if (v1406) {
      const v1425 = stdlib.sub(v1415, v1402);
      ;
      const v1429 = stdlib.sub(v1425, v1401);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  else {
    const v1474 = stdlib.add(v1405, v1402);
    const v1475 = stdlib.add(v1474, v1401);
    const v1479 = stdlib.sub(v829, v1475);
    ;
    const v1484 = stdlib.sub(v828, v828);
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 5,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1488, time: v1487, didSend: v683, from: v1486 } = txn4;
    ;
    const v1490 = stdlib.addressEq(v740, v1486);
    stdlib.assert(v1490, {
      at: './token.rsh:311:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Constructor'
      });
    if (v1406) {
      const v1494 = stdlib.sub(v1479, v1402);
      ;
      const v1498 = stdlib.sub(v1494, v1401);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  
  
  
  
  
  };
export async function Depositer(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Depositer expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Depositer expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_close0_161: ctc4,
    Bid_getBid0_161: ctc5,
    Bid_getPurchase0_161: ctc5,
    Bid_touch0_161: ctc4
    });
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 4,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v733, v734, v735, v736], secs: v738, time: v737, didSend: v36, from: v732 } = txn1;
  ;
  const v740 = v736;
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 13,
    funcNum: 1,
    out_tys: [ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc1],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v768, v769, v770, v771, v772, v773, v774, v775, v776, v777, v778, v779, v780], secs: v782, time: v781, didSend: v87, from: v767 } = txn2;
  const v783 = stdlib.tokenEq(v776, v777);
  const v784 = v783 ? false : true;
  stdlib.assert(v784, {
    at: './token.rsh:103:6:dot',
    fs: [],
    msg: 'non-network tokens distinct',
    who: 'Depositer'
    });
  ;
  ;
  ;
  stdlib.assert(v784, {
    at: './token.rsh:120:10:application',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  const v789 = stdlib.ge(v769, stdlib.checkedBigNumberify('./token.rsh:121:27:decimal', stdlib.UInt_max, 0));
  const v790 = stdlib.le(v769, stdlib.checkedBigNumberify('./token.rsh:121:48:decimal', stdlib.UInt_max, 99));
  const v791 = v789 ? v790 : false;
  stdlib.assert(v791, {
    at: './token.rsh:121:10:application',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  const v792 = stdlib.ge(v771, stdlib.checkedBigNumberify('./token.rsh:122:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v792, {
    at: './token.rsh:122:10:application',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  const v793 = stdlib.lt(v771, v770);
  stdlib.assert(v793, {
    at: './token.rsh:123:10:application',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  const v797 = stdlib.sub(stdlib.checkedBigNumberify('./token.rsh:119:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./token.rsh:126:12:decimal', stdlib.UInt_max, 20000));
  ;
  const v801 = stdlib.sub(v797, stdlib.checkedBigNumberify('./token.rsh:127:12:decimal', stdlib.UInt_max, 30000));
  ;
  const v805 = stdlib.sub(v801, stdlib.checkedBigNumberify('./token.rsh:128:12:decimal', stdlib.UInt_max, 50000));
  ;
  const v806 = ctc.iam(v767);
  const txn3 = await (ctc.sendrecv({
    args: [v734, v740, v767, v768, v769, v770, v771, v772, v773, v776, v777, v780, v805, v806],
    evt_cnt: 0,
    funcNum: 2,
    lct: v781,
    onlyIf: true,
    out_tys: [],
    pay: [stdlib.checkedBigNumberify('./token.rsh:134:11:decimal', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./token.rsh:134:15:decimal', stdlib.UInt_max, 1), v776]]],
    sim_p: (async (txn3) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [], secs: v809, time: v808, didSend: v116, from: v807 } = txn3;
      
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./token.rsh:134:11:decimal', stdlib.UInt_max, 0),
        kind: 'to',
        tok: undefined
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./token.rsh:134:15:decimal', stdlib.UInt_max, 1),
        kind: 'to',
        tok: v776
        });
      const v813 = stdlib.addressEq(v806, v807);
      stdlib.assert(v813, {
        at: './token.rsh:134:6:dot',
        fs: [],
        msg: 'sender correct',
        who: 'Depositer'
        });
      
      const v817 = stdlib.checkedBigNumberify('./token.rsh:170:24:decimal', stdlib.UInt_max, 0);
      const v818 = v780;
      const v819 = v767;
      const v820 = true;
      const v821 = v808;
      const v824 = v809;
      const v827 = v805;
      const v828 = stdlib.checkedBigNumberify('./token.rsh:134:15:decimal', stdlib.UInt_max, 1);
      const v829 = stdlib.checkedBigNumberify('./token.rsh:103:6:dot', stdlib.UInt_max, 0);
      
      if (await (async () => {
        
        return v820;})()) {
        const v844 = stdlib.add(v817, v772);
        const v845 = stdlib.div(v817, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
        const v846 = stdlib.mul(v845, v773);
        const v847 = stdlib.add(v817, v846);
        const v848 = stdlib.gt(v844, v847);
        const v849 = v848 ? v844 : v847;
        sim_r.isHalt = false;
        }
      else {
        const v1394 = stdlib.add(v817, v772);
        const v1395 = stdlib.div(v817, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
        const v1396 = stdlib.mul(v1395, v773);
        const v1397 = stdlib.add(v817, v1396);
        const v1398 = stdlib.gt(v1394, v1397);
        const v1399 = v1398 ? v1394 : v1397;
        const v1401 = stdlib.div(v829, stdlib.checkedBigNumberify('./token.rsh:273:34:decimal', stdlib.UInt_max, 100));
        const v1402 = stdlib.mul(v769, v1401);
        const v1404 = stdlib.add(v1402, v1401);
        const v1405 = stdlib.sub(v829, v1404);
        const v1406 = stdlib.ge(v817, v770);
        if (v1406) {
          const v1411 = stdlib.sub(v828, v828);
          sim_r.txns.push({
            amt: v828,
            kind: 'from',
            to: v819,
            tok: v776
            });
          const v1415 = stdlib.sub(v829, v1405);
          sim_r.txns.push({
            amt: v1405,
            kind: 'from',
            to: v767,
            tok: v777
            });
          sim_r.isHalt = false;
          }
        else {
          const v1474 = stdlib.add(v1405, v1402);
          const v1475 = stdlib.add(v1474, v1401);
          const v1479 = stdlib.sub(v829, v1475);
          sim_r.txns.push({
            amt: v1475,
            kind: 'from',
            to: v819,
            tok: v777
            });
          const v1484 = stdlib.sub(v828, v828);
          sim_r.txns.push({
            amt: v828,
            kind: 'from',
            to: v767,
            tok: v776
            });
          sim_r.isHalt = false;
          }}
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0],
    waitIfNotPresent: false
    }));
  const {data: [], secs: v809, time: v808, didSend: v116, from: v807 } = txn3;
  ;
  ;
  const v813 = stdlib.addressEq(v806, v807);
  stdlib.assert(v813, {
    at: './token.rsh:134:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Depositer'
    });
  stdlib.protect(ctc3, await interact.signal(), {
    at: './token.rsh:136:39:application',
    fs: ['at ./token.rsh:136:17:application call to [unknown function] (defined at: ./token.rsh:136:21:function exp)'],
    msg: 'signal',
    who: 'Depositer'
    });
  
  let v817 = stdlib.checkedBigNumberify('./token.rsh:170:24:decimal', stdlib.UInt_max, 0);
  let v818 = v780;
  let v819 = v767;
  let v820 = true;
  let v821 = v808;
  let v824 = v809;
  let v827 = v805;
  let v828 = stdlib.checkedBigNumberify('./token.rsh:134:15:decimal', stdlib.UInt_max, 1);
  let v829 = stdlib.checkedBigNumberify('./token.rsh:103:6:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    
    return v820;})()) {
    const v844 = stdlib.add(v817, v772);
    const v845 = stdlib.div(v817, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
    const v846 = stdlib.mul(v845, v773);
    const v847 = stdlib.add(v817, v846);
    const v848 = stdlib.gt(v844, v847);
    const v849 = v848 ? v844 : v847;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc6],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v943], secs: v945, time: v944, didSend: v565, from: v942 } = txn4;
    switch (v943[0]) {
      case 'Bid_close0_161': {
        const v946 = v943[1];
        ;
        ;
        undefined;
        const v995 = null;
        await txn4.getOutput('Bid_close', 'v995', ctc3, v995);
        const v1002 = stdlib.lt(v824, v818);
        const cv817 = v817;
        const cv818 = v818;
        const cv819 = v819;
        const cv820 = v1002;
        const cv821 = v944;
        const cv824 = v945;
        const cv827 = v827;
        const cv828 = v828;
        const cv829 = v829;
        
        v817 = cv817;
        v818 = cv818;
        v819 = cv819;
        v820 = cv820;
        v821 = cv821;
        v824 = cv824;
        v827 = cv827;
        v828 = cv828;
        v829 = cv829;
        
        continue;
        break;
        }
      case 'Bid_getBid0_161': {
        const v1058 = v943[1];
        const v1071 = v1058[stdlib.checkedBigNumberify('./token.rsh:202:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1104 = stdlib.add(v829, v1071);
        ;
        undefined;
        const v1119 = stdlib.lt(v824, v818);
        const v1126 = stdlib.ge(v1071, v849);
        const v1127 = v1119 ? v1126 : false;
        const v1128 = stdlib.ge(v1071, v771);
        const v1129 = v1127 ? v1128 : false;
        stdlib.assert(v1129, {
          at: './token.rsh:209:18:application',
          fs: ['at ./token.rsh:208:9:application call to [unknown function] (defined at: ./token.rsh:208:9:function exp)'],
          msg: null,
          who: 'Depositer'
          });
        const v1133 = stdlib.sub(v1104, v817);
        ;
        const v1134 = null;
        await txn4.getOutput('Bid_getBid', 'v1134', ctc3, v1134);
        const v1140 = stdlib.add(v818, stdlib.checkedBigNumberify('./token.rsh:158:33:decimal', stdlib.UInt_max, 60));
        const cv817 = v1071;
        const cv818 = v1140;
        const cv819 = v942;
        const cv820 = true;
        const cv821 = v944;
        const cv824 = v945;
        const cv827 = v827;
        const cv828 = v828;
        const cv829 = v1133;
        
        v817 = cv817;
        v818 = cv818;
        v819 = cv819;
        v820 = cv820;
        v821 = cv821;
        v824 = cv824;
        v827 = cv827;
        v828 = cv828;
        v829 = cv829;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0_161': {
        const v1170 = v943[1];
        const v1191 = v1170[stdlib.checkedBigNumberify('./token.rsh:227:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1216 = stdlib.add(v829, v1191);
        ;
        undefined;
        const v1257 = stdlib.ge(v824, v818);
        const v1258 = stdlib.lt(v817, v770);
        const v1259 = v1257 ? v1258 : false;
        const v1260 = stdlib.ge(v1191, v770);
        const v1261 = v1259 ? v1260 : false;
        stdlib.assert(v1261, {
          at: './token.rsh:235:18:application',
          fs: ['at ./token.rsh:234:9:application call to [unknown function] (defined at: ./token.rsh:234:9:function exp)'],
          msg: null,
          who: 'Depositer'
          });
        const v1265 = stdlib.sub(v1216, v817);
        ;
        const v1266 = null;
        await txn4.getOutput('Bid_getPurchase', 'v1266', ctc3, v1266);
        const cv817 = v1191;
        const cv818 = v818;
        const cv819 = v942;
        const cv820 = false;
        const cv821 = v944;
        const cv824 = v945;
        const cv827 = v827;
        const cv828 = v828;
        const cv829 = v1265;
        
        v817 = cv817;
        v818 = cv818;
        v819 = cv819;
        v820 = cv820;
        v821 = cv821;
        v824 = cv824;
        v827 = cv827;
        v828 = cv828;
        v829 = cv829;
        
        continue;
        break;
        }
      case 'Bid_touch0_161': {
        const v1282 = v943[1];
        ;
        ;
        undefined;
        const v1387 = null;
        await txn4.getOutput('Bid_touch', 'v1387', ctc3, v1387);
        const cv817 = v817;
        const cv818 = v818;
        const cv819 = v819;
        const cv820 = true;
        const cv821 = v944;
        const cv824 = v945;
        const cv827 = v827;
        const cv828 = v828;
        const cv829 = v829;
        
        v817 = cv817;
        v818 = cv818;
        v819 = cv819;
        v820 = cv820;
        v821 = cv821;
        v824 = cv824;
        v827 = cv827;
        v828 = cv828;
        v829 = cv829;
        
        continue;
        break;
        }
      }
    
    }
  const v1394 = stdlib.add(v817, v772);
  const v1395 = stdlib.div(v817, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
  const v1396 = stdlib.mul(v1395, v773);
  const v1397 = stdlib.add(v817, v1396);
  const v1398 = stdlib.gt(v1394, v1397);
  const v1399 = v1398 ? v1394 : v1397;
  const v1401 = stdlib.div(v829, stdlib.checkedBigNumberify('./token.rsh:273:34:decimal', stdlib.UInt_max, 100));
  const v1402 = stdlib.mul(v769, v1401);
  const v1404 = stdlib.add(v1402, v1401);
  const v1405 = stdlib.sub(v829, v1404);
  const v1406 = stdlib.ge(v817, v770);
  if (v1406) {
    const v1411 = stdlib.sub(v828, v828);
    ;
    const v1415 = stdlib.sub(v829, v1405);
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 4,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1419, time: v1418, didSend: v683, from: v1417 } = txn4;
    ;
    const v1421 = stdlib.addressEq(v740, v1417);
    stdlib.assert(v1421, {
      at: './token.rsh:311:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Depositer'
      });
    if (v1406) {
      const v1425 = stdlib.sub(v1415, v1402);
      ;
      const v1429 = stdlib.sub(v1425, v1401);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  else {
    const v1474 = stdlib.add(v1405, v1402);
    const v1475 = stdlib.add(v1474, v1401);
    const v1479 = stdlib.sub(v829, v1475);
    ;
    const v1484 = stdlib.sub(v828, v828);
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 5,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1488, time: v1487, didSend: v683, from: v1486 } = txn4;
    ;
    const v1490 = stdlib.addressEq(v740, v1486);
    stdlib.assert(v1490, {
      at: './token.rsh:311:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Depositer'
      });
    if (v1406) {
      const v1494 = stdlib.sub(v1479, v1402);
      ;
      const v1498 = stdlib.sub(v1494, v1401);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  
  
  
  
  
  };
export async function Relay(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Relay expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Relay expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_close0_161: ctc4,
    Bid_getBid0_161: ctc5,
    Bid_getPurchase0_161: ctc5,
    Bid_touch0_161: ctc4
    });
  const ctc7 = stdlib.T_Bool;
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 4,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v733, v734, v735, v736], secs: v738, time: v737, didSend: v36, from: v732 } = txn1;
  ;
  const v740 = ctc.iam(v736);
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 13,
    funcNum: 1,
    out_tys: [ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc1],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v768, v769, v770, v771, v772, v773, v774, v775, v776, v777, v778, v779, v780], secs: v782, time: v781, didSend: v87, from: v767 } = txn2;
  const v783 = stdlib.tokenEq(v776, v777);
  const v784 = v783 ? false : true;
  stdlib.assert(v784, {
    at: './token.rsh:103:6:dot',
    fs: [],
    msg: 'non-network tokens distinct',
    who: 'Relay'
    });
  ;
  ;
  ;
  stdlib.assert(v784, {
    at: './token.rsh:120:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v789 = stdlib.ge(v769, stdlib.checkedBigNumberify('./token.rsh:121:27:decimal', stdlib.UInt_max, 0));
  const v790 = stdlib.le(v769, stdlib.checkedBigNumberify('./token.rsh:121:48:decimal', stdlib.UInt_max, 99));
  const v791 = v789 ? v790 : false;
  stdlib.assert(v791, {
    at: './token.rsh:121:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v792 = stdlib.ge(v771, stdlib.checkedBigNumberify('./token.rsh:122:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v792, {
    at: './token.rsh:122:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v793 = stdlib.lt(v771, v770);
  stdlib.assert(v793, {
    at: './token.rsh:123:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v797 = stdlib.sub(stdlib.checkedBigNumberify('./token.rsh:119:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./token.rsh:126:12:decimal', stdlib.UInt_max, 20000));
  ;
  const v801 = stdlib.sub(v797, stdlib.checkedBigNumberify('./token.rsh:127:12:decimal', stdlib.UInt_max, 30000));
  ;
  const v805 = stdlib.sub(v801, stdlib.checkedBigNumberify('./token.rsh:128:12:decimal', stdlib.UInt_max, 50000));
  ;
  const v806 = v767;
  const txn3 = await (ctc.recv({
    didSend: false,
    evt_cnt: 0,
    funcNum: 2,
    out_tys: [],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [], secs: v809, time: v808, didSend: v116, from: v807 } = txn3;
  ;
  ;
  const v813 = stdlib.addressEq(v806, v807);
  stdlib.assert(v813, {
    at: './token.rsh:134:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Relay'
    });
  let v817 = stdlib.checkedBigNumberify('./token.rsh:170:24:decimal', stdlib.UInt_max, 0);
  let v818 = v780;
  let v819 = v767;
  let v820 = true;
  let v821 = v808;
  let v824 = v809;
  let v827 = v805;
  let v828 = stdlib.checkedBigNumberify('./token.rsh:134:15:decimal', stdlib.UInt_max, 1);
  let v829 = stdlib.checkedBigNumberify('./token.rsh:103:6:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    
    return v820;})()) {
    const v844 = stdlib.add(v817, v772);
    const v845 = stdlib.div(v817, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
    const v846 = stdlib.mul(v845, v773);
    const v847 = stdlib.add(v817, v846);
    const v848 = stdlib.gt(v844, v847);
    const v849 = v848 ? v844 : v847;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc6],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v943], secs: v945, time: v944, didSend: v565, from: v942 } = txn4;
    switch (v943[0]) {
      case 'Bid_close0_161': {
        const v946 = v943[1];
        ;
        ;
        undefined;
        const v995 = null;
        await txn4.getOutput('Bid_close', 'v995', ctc3, v995);
        const v1002 = stdlib.lt(v824, v818);
        const cv817 = v817;
        const cv818 = v818;
        const cv819 = v819;
        const cv820 = v1002;
        const cv821 = v944;
        const cv824 = v945;
        const cv827 = v827;
        const cv828 = v828;
        const cv829 = v829;
        
        v817 = cv817;
        v818 = cv818;
        v819 = cv819;
        v820 = cv820;
        v821 = cv821;
        v824 = cv824;
        v827 = cv827;
        v828 = cv828;
        v829 = cv829;
        
        continue;
        break;
        }
      case 'Bid_getBid0_161': {
        const v1058 = v943[1];
        const v1071 = v1058[stdlib.checkedBigNumberify('./token.rsh:202:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1104 = stdlib.add(v829, v1071);
        ;
        undefined;
        const v1119 = stdlib.lt(v824, v818);
        const v1126 = stdlib.ge(v1071, v849);
        const v1127 = v1119 ? v1126 : false;
        const v1128 = stdlib.ge(v1071, v771);
        const v1129 = v1127 ? v1128 : false;
        stdlib.assert(v1129, {
          at: './token.rsh:209:18:application',
          fs: ['at ./token.rsh:208:9:application call to [unknown function] (defined at: ./token.rsh:208:9:function exp)'],
          msg: null,
          who: 'Relay'
          });
        const v1133 = stdlib.sub(v1104, v817);
        ;
        const v1134 = null;
        await txn4.getOutput('Bid_getBid', 'v1134', ctc3, v1134);
        const v1140 = stdlib.add(v818, stdlib.checkedBigNumberify('./token.rsh:158:33:decimal', stdlib.UInt_max, 60));
        const cv817 = v1071;
        const cv818 = v1140;
        const cv819 = v942;
        const cv820 = true;
        const cv821 = v944;
        const cv824 = v945;
        const cv827 = v827;
        const cv828 = v828;
        const cv829 = v1133;
        
        v817 = cv817;
        v818 = cv818;
        v819 = cv819;
        v820 = cv820;
        v821 = cv821;
        v824 = cv824;
        v827 = cv827;
        v828 = cv828;
        v829 = cv829;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0_161': {
        const v1170 = v943[1];
        const v1191 = v1170[stdlib.checkedBigNumberify('./token.rsh:227:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1216 = stdlib.add(v829, v1191);
        ;
        undefined;
        const v1257 = stdlib.ge(v824, v818);
        const v1258 = stdlib.lt(v817, v770);
        const v1259 = v1257 ? v1258 : false;
        const v1260 = stdlib.ge(v1191, v770);
        const v1261 = v1259 ? v1260 : false;
        stdlib.assert(v1261, {
          at: './token.rsh:235:18:application',
          fs: ['at ./token.rsh:234:9:application call to [unknown function] (defined at: ./token.rsh:234:9:function exp)'],
          msg: null,
          who: 'Relay'
          });
        const v1265 = stdlib.sub(v1216, v817);
        ;
        const v1266 = null;
        await txn4.getOutput('Bid_getPurchase', 'v1266', ctc3, v1266);
        const cv817 = v1191;
        const cv818 = v818;
        const cv819 = v942;
        const cv820 = false;
        const cv821 = v944;
        const cv824 = v945;
        const cv827 = v827;
        const cv828 = v828;
        const cv829 = v1265;
        
        v817 = cv817;
        v818 = cv818;
        v819 = cv819;
        v820 = cv820;
        v821 = cv821;
        v824 = cv824;
        v827 = cv827;
        v828 = cv828;
        v829 = cv829;
        
        continue;
        break;
        }
      case 'Bid_touch0_161': {
        const v1282 = v943[1];
        ;
        ;
        undefined;
        const v1387 = null;
        await txn4.getOutput('Bid_touch', 'v1387', ctc3, v1387);
        const cv817 = v817;
        const cv818 = v818;
        const cv819 = v819;
        const cv820 = true;
        const cv821 = v944;
        const cv824 = v945;
        const cv827 = v827;
        const cv828 = v828;
        const cv829 = v829;
        
        v817 = cv817;
        v818 = cv818;
        v819 = cv819;
        v820 = cv820;
        v821 = cv821;
        v824 = cv824;
        v827 = cv827;
        v828 = cv828;
        v829 = cv829;
        
        continue;
        break;
        }
      }
    
    }
  const v1394 = stdlib.add(v817, v772);
  const v1395 = stdlib.div(v817, stdlib.checkedBigNumberify('./token.rsh:18:37:decimal', stdlib.UInt_max, 100));
  const v1396 = stdlib.mul(v1395, v773);
  const v1397 = stdlib.add(v817, v1396);
  const v1398 = stdlib.gt(v1394, v1397);
  const v1399 = v1398 ? v1394 : v1397;
  const v1401 = stdlib.div(v829, stdlib.checkedBigNumberify('./token.rsh:273:34:decimal', stdlib.UInt_max, 100));
  const v1402 = stdlib.mul(v769, v1401);
  const v1404 = stdlib.add(v1402, v1401);
  const v1405 = stdlib.sub(v829, v1404);
  const v1406 = stdlib.ge(v817, v770);
  if (v1406) {
    const v1411 = stdlib.sub(v828, v828);
    ;
    const v1415 = stdlib.sub(v829, v1405);
    ;
    const txn4 = await (ctc.sendrecv({
      args: [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1411, v1415],
      evt_cnt: 0,
      funcNum: 4,
      lct: v821,
      onlyIf: true,
      out_tys: [],
      pay: [stdlib.checkedBigNumberify('./token.rsh:311:7:decimal', stdlib.UInt_max, 0), []],
      sim_p: (async (txn4) => {
        const sim_r = { txns: [], mapRefs: [], maps: [] };
        
        const {data: [], secs: v1419, time: v1418, didSend: v683, from: v1417 } = txn4;
        
        sim_r.txns.push({
          amt: stdlib.checkedBigNumberify('./token.rsh:311:7:decimal', stdlib.UInt_max, 0),
          kind: 'to',
          tok: undefined
          });
        const v1421 = stdlib.addressEq(v740, v1417);
        stdlib.assert(v1421, {
          at: './token.rsh:311:7:dot',
          fs: [],
          msg: 'sender correct',
          who: 'Relay'
          });
        if (v1406) {
          const v1425 = stdlib.sub(v1415, v1402);
          sim_r.txns.push({
            amt: v1402,
            kind: 'from',
            to: v768,
            tok: v777
            });
          const v1429 = stdlib.sub(v1425, v1401);
          sim_r.txns.push({
            amt: v1401,
            kind: 'from',
            to: v734,
            tok: v777
            });
          sim_r.txns.push({
            amt: v827,
            kind: 'from',
            to: v734,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1411,
            kind: 'from',
            to: v734,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1429,
            kind: 'from',
            to: v734,
            tok: undefined
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v777
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v776
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          }
        else {
          sim_r.txns.push({
            amt: v827,
            kind: 'from',
            to: v734,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1411,
            kind: 'from',
            to: v734,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1415,
            kind: 'from',
            to: v734,
            tok: undefined
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v777
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v776
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          }
        return sim_r;
        }),
      soloSend: true,
      timeoutAt: undefined,
      tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc7, ctc1, ctc1],
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1419, time: v1418, didSend: v683, from: v1417 } = txn4;
    ;
    const v1421 = stdlib.addressEq(v740, v1417);
    stdlib.assert(v1421, {
      at: './token.rsh:311:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Relay'
      });
    if (v1406) {
      const v1425 = stdlib.sub(v1415, v1402);
      ;
      const v1429 = stdlib.sub(v1425, v1401);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  else {
    const v1474 = stdlib.add(v1405, v1402);
    const v1475 = stdlib.add(v1474, v1401);
    const v1479 = stdlib.sub(v829, v1475);
    ;
    const v1484 = stdlib.sub(v828, v828);
    ;
    const txn4 = await (ctc.sendrecv({
      args: [v734, v740, v767, v768, v769, v770, v771, v776, v777, v817, v818, v819, v827, v1399, v1401, v1402, v1406, v1479, v1484],
      evt_cnt: 0,
      funcNum: 5,
      lct: v821,
      onlyIf: true,
      out_tys: [],
      pay: [stdlib.checkedBigNumberify('./token.rsh:311:7:decimal', stdlib.UInt_max, 0), []],
      sim_p: (async (txn4) => {
        const sim_r = { txns: [], mapRefs: [], maps: [] };
        
        const {data: [], secs: v1488, time: v1487, didSend: v683, from: v1486 } = txn4;
        
        sim_r.txns.push({
          amt: stdlib.checkedBigNumberify('./token.rsh:311:7:decimal', stdlib.UInt_max, 0),
          kind: 'to',
          tok: undefined
          });
        const v1490 = stdlib.addressEq(v740, v1486);
        stdlib.assert(v1490, {
          at: './token.rsh:311:7:dot',
          fs: [],
          msg: 'sender correct',
          who: 'Relay'
          });
        if (v1406) {
          const v1494 = stdlib.sub(v1479, v1402);
          sim_r.txns.push({
            amt: v1402,
            kind: 'from',
            to: v768,
            tok: v777
            });
          const v1498 = stdlib.sub(v1494, v1401);
          sim_r.txns.push({
            amt: v1401,
            kind: 'from',
            to: v734,
            tok: v777
            });
          sim_r.txns.push({
            amt: v827,
            kind: 'from',
            to: v734,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1484,
            kind: 'from',
            to: v734,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1498,
            kind: 'from',
            to: v734,
            tok: undefined
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v777
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v776
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          }
        else {
          sim_r.txns.push({
            amt: v827,
            kind: 'from',
            to: v734,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1484,
            kind: 'from',
            to: v734,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1479,
            kind: 'from',
            to: v734,
            tok: undefined
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v777
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v776
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          }
        return sim_r;
        }),
      soloSend: true,
      timeoutAt: undefined,
      tys: [ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc7, ctc1, ctc1],
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1488, time: v1487, didSend: v683, from: v1486 } = txn4;
    ;
    const v1490 = stdlib.addressEq(v740, v1486);
    stdlib.assert(v1490, {
      at: './token.rsh:311:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Relay'
      });
    if (v1406) {
      const v1494 = stdlib.sub(v1479, v1402);
      ;
      const v1498 = stdlib.sub(v1494, v1401);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  
  
  
  
  
  };
const _ALGO = {
  appApproval: `BSAdAAEECIABoI0GiAGQAZgBoAGoAbABBQLoAfABZAOgnAGw6gHQhgO4AcAB2AHgAfkBgQIHCiYDAQEAAQIxIDIDEkQxBjIDEkQiNQAxGEEOMilkSSJbNQElWzUCMRshERJENhoAF0kiEkEAtkgiNAESRDYaARdJIhJMNAISEUQpSDYaAkkVIQQSRElXACA1/0lXICA1/klXQCA1/UlXYCA1/EiABGU5Mzc0/1A0/lA0/VA0/FCwIQVJQQA0NABJIwg1AExLATgIEkQjSwE4EBJEIksBOAESRDIDSwE4BhJEMgNLATggEkQyCksBOAcSREg0/DX7NP80/lA0/VA0/FA0+1Ajr0sBVwB/ZyhLAVd/IWdIIzUBMgY1AjEZIhJEQg1ASSMSQQJfSCM0ARJENhoBF0kiEkw0AhIRRCOvZChkUElXACA1/0lXICA1/klXQCA1/UlXYCA1/ElXgCA1+0g2GgJJFSEEEkRJVwAgNfpJgSBbNflJgShbNfhJgTBbNfdJgThbNfZJgUBbNfVJgUhbNfRJgVBbNfNJgVhbNfJJgWBbNfFJgWhbNfBJgXBbNe9JgXhbNe5IgAQ0NjIyNPpQNPkWUDT4FlA09xZQNPYWUDT1FlA09BZQNPMWUDTyFlA08RZQNPAWUDTvFlA07hZQsDTyNPESFDXtNO1EIQVJQQA0NABJIwg1AExLATgIEkQjSwE4EBJEIksBOAESRDIDSwE4BhJEMgNLATggEkQyCksBOAcSREgisbISJLIQMgqyFDTyshGzIkghBUlBADQ0AEkjCDUATEsBOAgSRCNLATgQEkQiSwE4ARJEMgNLATgGEkQyA0sBOCASRDIKSwE4BxJESCKxshIkshAyCrIUNPGyEbMiSCEFSUEANDQASSMINQBMSwE4CBJEI0sBOBASRCJLATgBEkQyA0sBOAYSRDIDSwE4IBJEMgpLATgHEkRINO1ENPkiDzT5gWMOEEQ09yIPRDT3NPgMRCESSUEADLGyCCOyEDT/sgezIkghE0lBAAyxsggjshA0/bIHsyJIIQUhEgkhEwkhFAk17CEUSUEADLGyCCOyEDT8sgezIkgxADXrNP40+1AxAFA0+lA0+RZQNPgWUDT3FlA09hZQNPUWUDTyFlA08RZQNO4WUDTsFlA061Ajr0sBVwB/ZyhLAVd/aWdIIQ01ATIGNQIxGSISREIK20khDRJBARpIIQ00ARJENhoBF0kiEkw0AhIRRCOvZChkUElXACA1/0lXICA1/klXQCA1/UlXYCA1/EkhBFs1+0khBls1+kkhB1s1+UkhCFs1+EkhCVs190khCls19kkhC1s19UkhFVs19EkhFls180lXyCA18kg2GgJJFSISREiABDQxYjGwI0lBADw0AEkjCDUATEsBOBISRDT2SwE4ERJEJEsBOBASRCJLATgBEkQyA0sBOAYSRDIDSwE4IBJEMgpLATgUEkRINPIxABJENP80/lA0/VA0/FA0+xZQNPoWUDT5FlA0+BZQNPcWUDT2FlA09RZQJa809BZQNP1QIxZRBwhQMgYWUDIHFlA08xZQgAgAAAAAAAAAAVAlr1BCBxZJJBJBAeFIJDQBEkQ2GgEXSSISTDQCEhFEI69kKGRQKmRQSVcAIDX/SVcgIDX+SVdAIDX9SVdgIDX8SSEEWzX7SSEGWzX6SSEHWzX5SSEIWzX4SSEJWzX3SSEKWzX2SSELWzX1SVe4IDX0SSEXWzXzSSEYWzXySSEOWzXxSSEPWzXwSVf4ARc170khGVs17kkhGiVYFzXtSDYaAkkVIhJESIAEOTEyN7A0/jEAEkQ070EAtDTwSUEAELGyEiSyEDT8shQ097IRsyJINPFJQQAQsbISJLIQNP+yFDT3shGzIkg080lBAAyxsggjshA0/7IHsyJINO5JQQAMsbIII7IQNP+yB7MiSDTtNPAJNPEJSUEADLGyCCOyEDT/sgezIkgisbISJLIQMgmyFTIKshQ097IRsyJIIrGyEiSyEDIJshUyCrIUNPiyEbMiSCKxsggjshAyCbIJMgqyB7MiSDEZIQwSREIIUzTzSUEADLGyCCOyEDT/sgezIkg07klBAAyxsggjshA0/7IHsyJINO1JQQAMsbIII7IQNP+yB7MiSCKxshIkshAyCbIVMgqyFDT3shGzIkgisbISJLIQMgmyFTIKshQ0+LIRsyJIIrGyCCOyEDIJsgkyCrIHsyJIMRkhDBJEQgfTSSEMEkEB4kghGzQBEkQ2GgEXSSISTDQCEhFEI69kKGRQKmRQSVcAIDX/SVcgIDX+SVdAIDX9SVdgIDX8SSEEWzX7SSEGWzX6SSEHWzX5SSEIWzX4SSEJWzX3SSEKWzX2SSELWzX1SVe4IDX0SSEXWzXzSSEYWzXySSEOWzXxSSEPWzXwSVf4ARc170khGVs17kkhGiVYFzXtSDYaAkkVIhJESIAEY2M5ObA0/jEAEkQ070EAtDTwSUEAELGyEiSyEDT8shQ097IRsyJINPFJQQAQsbISJLIQNP+yFDT3shGzIkg080lBAAyxsggjshA0/7IHsyJINO1JQQAMsbIII7IQNP+yB7MiSDTuNPAJNPEJSUEADLGyCCOyEDT/sgezIkgisbISJLIQMgmyFTIKshQ097IRsyJIIrGyEiSyEDIJshUyCrIUNPiyEbMiSCKxsggjshAyCbIJMgqyB7MiSDEZIQwSREIGajTzSUEADLGyCCOyEDT/sgezIkg07UlBAAyxsggjshA0/7IHsyJINO5JQQAMsbIII7IQNP+yB7MiSCKxshIkshAyCbIVMgqyFDT3shGzIkgisbISJLIQMgmyFTIKshQ0+LIRsyJIIrGyCCOyEDIJsgkyCrIHsyJIMRkhDBJEQgXqSYEGEkEDPUghHDQBEkQ2GgEXSSISTDQCEhFEI69kKGRQKmRQSVcAIDX/SVcgIDX+SVdAIDX9SVdgIDX8SSEEWzX7SSEGWzX6SSEHWzX5SSEIWzX4SSEJWzX3SSEKWzX2SSELWzX1SSEVWzX0SSEWWzXzSVfIIDXySSEOWzXxSSEPWzXwSYH4AVs170mBgAIlWBc17kmBiAIlWBc17Ug2GgJJFYEJEkRJNexIgARlYjk1NOxQsDTsIlUiEkEAXoAIAAAAAAAAA+OwKTT/NP5QNP1QNPxQNPsWUDT6FlA0+RZQNPgWUDT3FlA09hZQNPUWUDT0FjTzFlA08lA08TTzDBZRBwhQMgYWUDIHFlA08BZQNO8WUDTuFlBCAio07CJVIxJBANo07FcBCEk16xc16jTqSUEAPDQASSMINQBMSwE4EhJENPVLATgREkQkSwE4EBJEIksBOAESRDIDSwE4BhJEMgNLATggEkQyCksBOBQSREg08TTzDDTqNO0PEDTqNPkPEEQ09ElBABCxshIkshA08rIUNPWyEbMiSIAIAAAAAAAABG6wKTT/NP5QNP1QNPxQNPsWUDT6FlA0+RZQNPgWUDT3FlA09hZQNPUWUDTqFjTzgTwIFlAxAFAjFlEHCFAyBhZQMgcWUDTwFlA07xZQNO406gg09AkWUEIBRzTsIlUhDRJBANc07FcBCEk16xc16jTqSUEAPDQASSMINQBMSwE4EhJENPVLATgREkQkSwE4EBJEIksBOAESRDIDSwE4BhJEMgNLATggEkQyCksBOBQSREg08TTzDzT0NPoMEDTqNPoPEEQ09ElBABCxshIkshA08rIUNPWyEbMiSIAIAAAAAAAABPKwKTT/NP5QNP1QNPxQNPsWUDT6FlA0+RZQNPgWUDT3FlA09hZQNPUWUDTqFjTzFlAxAFAiFlEHCFAyBhZQMgcWUDTwFlA07xZQNO406gg09AkWUEIAZjTsIlUhERJBAFqACAAAAAAAAAVrsCk0/zT+UDT9UDT8UDT7FlA0+hZQNPkWUDT4FlA09xZQNPYWUDT1FlA09BY08xZQNPJQIxZRBwhQMgYWUDIHFlA08BZQNO8WUDTuFlBCAAIiREkiWzX/SSVbNf5JVxAgNf1JVzABFzX8SYExWzX7SYE5WzX6SYFBWzX5SYFJWzX4SYFRWzX3SElXACA19klXICA19UlXQCA19ElXYCA180khBFs18kkhBls18UkhB1s18EkhCFs170khCVs17kkhCls17UkhC1s17Eg0/EEAijT/NO8INes0/0khEAo07gsISTXqNOtJNOoNTTXpNPY09VA09FA081A08hZQNPEWUDTwFlA07xZQNO4WUDTtFlA07BZQNP8WUDT+FlA0/VA0+hZQNPkWUDT4FlA09xZQNOkWUCOvSwFXAH9nKEsBV39/ZypLAVf+EmdIIRw1ATIGNQIxGSISREIBnDT/NO8INes0/0khEAo07gsISTXqNOtJNOoNTTXpNPchEAo16DTyNOgLNec09zTnNOgICTXmNP808Q9JNeVBAKo0+EkJNeQ0+ElBABCxshIkshA0/bIUNO2yEbMiSDT3NOYJNeM05klBABCxshIkshA09LIUNOyyEbMiSDT2NPVQNPRQNPNQNPIWUDTxFlA08BZQNO0WUDTsFlA0/xZQNP4WUDT9UDT5FlA06RZQNOgWUDTnFlA05RZRBwhQNOQWUDTjFlAjr0sBVwB/ZyhLAVd/f2cqSwFX/gtnSCQ1ATIGNQIxGSISREIAsjTmNOcINOgINeQ09zTkCTXjNORJQQAQsbISJLIQNP2yFDTsshGzIkg0+EkJNeI0+ElBABCxshIkshA09LIUNO2yEbMiSDT2NPVQNPRQNPNQNPIWUDTxFlA08BZQNO0WUDTsFlA0/xZQNP4WUDT9UDT5FlA06RZQNOgWUDTnFlA05RZRBwhQNOMWUDTiFlAjr0sBVwB/ZyhLAVd/f2cqSwFX/gtnSCEbNQEyBjUCMRkiEkQpNAEWNAIWUGc0AElJIwgyBBJEMRYSRIHoBwsxAQ5EI0MxGSISRCI1ASI1AkL/0Q==`,
  appClear: `BYEA`,
  extraPages: 1,
  mapDataKeys: 0,
  mapDataSize: 0,
  stateKeys: 3,
  stateSize: 272,
  unsupported: [],
  version: 8
  };
const _ETH = {
  ABI: `[
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v733",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v734",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v735",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v736",
                "type": "address"
              }
            ],
            "internalType": "struct T5",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T6",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "stateMutability": "payable",
    "type": "constructor"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "msg",
        "type": "uint256"
      }
    ],
    "name": "ReachError",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v733",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v734",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v735",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v736",
                "type": "address"
              }
            ],
            "internalType": "struct T5",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T6",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e0",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v768",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v769",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v770",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v771",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v772",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v773",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v774",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v775",
                "type": "uint256"
              },
              {
                "internalType": "address payable",
                "name": "v776",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v777",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v778",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v779",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v780",
                "type": "uint256"
              }
            ],
            "internalType": "struct T7",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T8",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e1",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "indexed": false,
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e2",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "indexed": false,
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e4",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "indexed": false,
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e5",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T16",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_close0_161",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T15",
                    "name": "_Bid_getBid0_161",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T15",
                    "name": "_Bid_getPurchase0_161",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_touch0_161",
                    "type": "tuple"
                  }
                ],
                "internalType": "struct T16",
                "name": "v943",
                "type": "tuple"
              }
            ],
            "internalType": "struct T17",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T18",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e6",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1134",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1266",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1387",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v995",
    "type": "event"
  },
  {
    "stateMutability": "payable",
    "type": "fallback"
  },
  {
    "inputs": [],
    "name": "Auction_bids",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_closed",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_closes",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_currentPrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_endCTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_endSecs",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_highestBidder",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_lastCTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_minBid",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_reservePrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_royalties",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_startPrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_token",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_tokenP",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bool",
        "name": "_a0",
        "type": "bool"
      }
    ],
    "name": "Bid_close",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_a0",
        "type": "uint256"
      }
    ],
    "name": "Bid_getBid",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_a0",
        "type": "uint256"
      }
    ],
    "name": "Bid_getPurchase",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bool",
        "name": "_a0",
        "type": "bool"
      }
    ],
    "name": "Bid_touch",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCreationTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCurrentState",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCurrentTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v768",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v769",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v770",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v771",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v772",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v773",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v774",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v775",
                "type": "uint256"
              },
              {
                "internalType": "address payable",
                "name": "v776",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v777",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v778",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v779",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v780",
                "type": "uint256"
              }
            ],
            "internalType": "struct T7",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T8",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m1",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m2",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m4",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m5",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T16",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_close0_161",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T15",
                    "name": "_Bid_getBid0_161",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T15",
                    "name": "_Bid_getPurchase0_161",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_touch0_161",
                    "type": "tuple"
                  }
                ],
                "internalType": "struct T16",
                "name": "v943",
                "type": "tuple"
              }
            ],
            "internalType": "struct T17",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T18",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m6",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "stateMutability": "payable",
    "type": "receive"
  }
]`,
  Bytecode: `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`,
  BytecodeLen: 27448,
  Which: `oD`,
  version: 6,
  views: {
    Auction: {
      bids: `Auction_bids`,
      closed: `Auction_closed`,
      closes: `Auction_closes`,
      currentPrice: `Auction_currentPrice`,
      endCTime: `Auction_endCTime`,
      endSecs: `Auction_endSecs`,
      highestBidder: `Auction_highestBidder`,
      lastCTime: `Auction_lastCTime`,
      minBid: `Auction_minBid`,
      owner: `Auction_owner`,
      reservePrice: `Auction_reservePrice`,
      royalties: `Auction_royalties`,
      startPrice: `Auction_startPrice`,
      token: `Auction_token`,
      tokenP: `Auction_tokenP`
      }
    }
  };
export const _Connectors = {
  ALGO: _ALGO,
  ETH: _ETH
  };
export const _Participants = {
  "Auctioneer": Auctioneer,
  "Bid_close": Bid_close,
  "Bid_getBid": Bid_getBid,
  "Bid_getPurchase": Bid_getPurchase,
  "Bid_touch": Bid_touch,
  "Constructor": Constructor,
  "Depositer": Depositer,
  "Relay": Relay
  };
export const _APIs = {
  Bid: {
    close: Bid_close,
    getBid: Bid_getBid,
    getPurchase: Bid_getPurchase,
    touch: Bid_touch
    }
  };
